<div class="row mt-2" *ngIf="!isViewScreen && !isViewProviderAdmin">
  <div class="col">
    <small (click)="showSearchResult = false">
      <a [routerLink]="['/provider/dashboard']" class="text-secondary">Admin Console </a>
      /<a class="text-secondary"> Account Management</a>
    </small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()"> / Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div class="row mt-2" *ngIf="isViewProviderAdmin">
  <div class="col">
    <small (click)="showSearchResult = false">
      <a [routerLink]="['/dashboard']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/dongle-providers']" class="text-secondary"> Dongle Providers</a>
      <a *ngIf="isSearchResult" class="text-secondary"> / Search</a>
      /<span *ngIf="provider" (click)="isViewScreen = false; isViewProviderAdmin = false"
        class="text-secondary pointer"> {{provider.name}}</span>
    </small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()"> / Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
    /<span class="text-secondary"> {{selectedProviderAdmin.name}}</span>
  </div>
</div>

<div *ngIf="showSearchResult" class="row mt-2">
  <div class="col-12">
    <app-search-results [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult && !isViewScreen && !isViewProviderAdmin">
  <div class="row  pt-2">


    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12">
      <div class="row pt-2">
        <div class="col-4 text-center">
          <a class="pointer font14-700" [routerLink]="['/provider/dongles']">DONGLES ></a>
        </div>
        <!-- <div class="col-4 text-center">
          <a class="pointer font14-700" [routerLink]="['/rental-fleet/usage']"
            [queryParams]="{fleetId: account.id, accountType: accountType, isSearchResult: isSearchResult}">USAGE ></a>
        </div>
        <div class="col-4 text-center">
          <a class="pointer font14-700" [routerLink]="['/rental-fleet/vehicles']"
            [queryParams]="{accountType: accountType, isSearchResult: isSearchResult}">VEHICLES ></a>
        </div> -->
        <!-- <div class="col-xl-1 col-lg-1 d-md-none"></div> -->
      </div>
    </div>

    <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 text-right">
      <div class="row">
        <div class="col-12 text-right">
          <button class="btn btn-primary border" data-toggle="modal" data-target="#inviteAdmin"
            data-backdrop="static" data-keyboard="false" data-dismiss="modal">Add Admin
            <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span>-->
            </button> 
          <!-- <button class="btn btn-primary border mr-3" (click)="getApiKey()" data-toggle="modal" data-target="#apiAccess"
            data-backdrop="static" data-keyboard="false">API Access
            &nbsp;<span><i class="fas fa-chevron-right"></i></span></button>
        
          <button class="btn btn-primary border mr-3" data-toggle="modal" data-target="#billing" data-backdrop="static"
            data-keyboard="false">Billing Profile
            &nbsp;<span><i class="fas fa-chevron-right"></i></span></button> -->

        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3 bg-light no-gutter pb-1">
    <div class="col-lg-2 col-md-2 col-sm-6 col-4 text-center mt-1 pr-0">
      <img *ngIf="provider.logo" class="img-fluid" src="{{provider.logo}}" alt="{{provider.name}}"
        style="width:auto; height: 8vh" />
      <img *ngIf="!provider.logo" class="img-fluid" src="assets/images/placeholder.png" alt="alt"
        style="width:auto; height: 8vh" />
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-8 mt-1">
      <div class="font14-700 cursor-pointer" (click)="openUpdate()">{{provider.name}}
        &nbsp;<span
          [ngClass]="{'ACTIVE':'badge-success', 'INACTIVE':'badge-danger', 'SUSPENDED':'badge-danger', 'PENDING':'badge-warning', 'ENABLED':'badge-warning'}[provider.status]"
          class="badge badge-pill badge-400"> {{provider.status | customText}}</span>
      </div>
      <div *ngIf="provider.contactPoints && provider.contactPoints.addresses && provider.contactPoints && provider.contactPoints.addresses.length > 0" class="font13-400 mt-1">
        {{provider.contactPoints.addresses[0].street}}
        <!-- <i class="fas fa-edit cursor-pointer ml-3 maroon" data-toggle="tooltip" data-placement="right"
          title="Update Provider Detail" (click)="openUpdate()"></i>  -->
        <br>
        {{provider.contactPoints.addresses[0].city}}, {{provider.contactPoints.addresses[0].state}},
        {{provider.contactPoints.addresses[0].postalCode}}
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-6 col-4 text-center mt-1 pr-0">
      <div class="font14-600">{{provider.dongles}}</div>
      <div class="font13-400 mt-1">Active Dongles</div>
    </div>
    <!-- <div class="col-lg-4 col-md-4 col-sm-6 col-8 mt-1">
      <span *ngIf="account.type=='VEHICLE_SERVICE_PROVIDER'; else showFleetCustomerId">
        <div class="w-break font13-600 text-right">Service Provider Id : <span
            class="font13-400">{{account.oemCustomerId}}</span> </div>
      </span>
      <ng-template #showFleetCustomerId>
        <div class="w-break font13-600 text-right">Fleet Customer Id : <span
            class="font13-400">{{account.oemCustomerId}}</span> </div>
      </ng-template>
      <div class="w-break mt-1 font13-600 text-right">Account Id : <span class="font13-400">{{account.id}}</span></div>
    </div> -->
  </div>


  <div class="border row mt-3 no-gutter">
    <!-- <div class="col-sm-2 align-center mt-2 d-none d-sm-block">
      <span>Fleet Account Administrator</span><br>
      <h3>{{accountAdministrator.length}}</h3>
      <a class="pointer" data-toggle="modal" data-target="#inviteAdmin" data-backdrop="static"
        data-keyboard="false" data-dismiss="modal"><small class="maroon"><u>Invite B2B Admin</u></small></a>
    </div>
    <div class="col-sm-2 align-center mt-2 d-block d-sm-none">
      <h6>Fleet Account Administrator : {{accountAdministrator.length}}</h6>
    </div> -->
    <div class="col-12 mt-2 mb-2 heading">Dongle Provider Administrators</div>
    <div class="col-sm table-responsive scroll-height-150 no-gutter">
      <table class="table table-striped tbl-scrollable">
        <thead class="thead-light">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody class="max-height-25">
          <tr *ngFor="let admin of providerAdministrator">
            <td class="pointer" (click)="providerAdminClicked(admin)">{{admin.name}}</td>
            <td class="pointer" (click)="providerAdminClicked(admin)">{{admin.username}}</td>
            <td class="pointer" (click)="providerAdminClicked(admin)">{{admin.phone}}</td>
            <td>
              <i *ngIf="admin.status=='ACTIVE' || admin.status=='ENABLED'" class="fa fa-check-circle text-success"
                aria-hidden="true"></i>
              <i *ngIf="admin.status=='DISABLED'" class="fa fa-exclamation-circle text-danger" aria-hidden="true"></i>
              <i *ngIf="admin.status=='INVITED'" class="fa fa-minus-circle text-warning" aria-hidden="true"></i>
              {{admin.status | customText}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<!-- <div *ngIf="isViewProviderAdmin">
  <app-dongle-provider-user-detail [admin]="selectedProviderAdmin" (closeEmitter)="closeOfProviderAdminClicked($event)">
  </app-dongle-provider-user-detail>
</div> -->

<!-- Modal Invite B2B Primary Account Admin -->
<button type="button" class="btn btn-primary" id="openInviteAdmin" [hidden]="true" data-toggle="modal"
  data-target="#inviteAdmin" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden Btn</button>

<div class="modal" id="inviteAdmin" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="inviteAdminTitle">Invite Dongle Provider Admin
        </h5>
        <button type="button" id="closeInviteAdminModel" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetInviteProviderAdminForm()">&times;</span>
        </button>
      </div>
      <form #inviteProviderAdminForm="ngForm" novalidate (ngSubmit)="inviteAdminSubmit(inviteProviderAdminForm)">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!inviteProviderAdminModal[0].image">
                <img src="assets/images/person.jpg" class="img-thumbnail full-img">
              </div>
              <div *ngIf="inviteProviderAdminModal[0].image">
                <img [src]="inviteProviderAdminModal[0].image" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploadUserLogo id="uploadUserLogo" name="uploadUserLogo" type="file"
                  (click)="uploadUserLogo.value=null" (change)="uploadUserImage($event)" accept=".jpg,.png">
              </div>
              <small><a style="cursor:pointer" (click)="changeUploadUserLogoClicked()"><u>Upload
                    Image</u></a></small>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group mb-1">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Admin
                  Name</label>
                <input type="text" class="form-control" [(ngModel)]="inviteProviderAdminModal[0].name" name="name"
                  #name="ngModel" required>
                <small class="text-danger text-center" *ngIf="name.errors && inviteProviderAdminForm.submitted">
                  <p class="mb-0" *ngIf="name.errors.required">*Required</p>
                </small>
              </div>

              <div class="form-group mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Email
                  Address</label>
                <input type="email" class="form-control" [(ngModel)]="inviteProviderAdminModal[0].username" name="email"
                  #email="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$" required email>
                <small class="text-danger text-center" *ngIf="email.errors && inviteProviderAdminForm.submitted">
                  <p class="mb-0" *ngIf="email.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!email.errors.required">Invalid email</p>
                </small>
              </div>

              <div class="form-group mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Phone
                  Number</label>
                <input type="text" class="form-control" [(ngModel)]="inviteProviderAdminModal[0].phone" name="phone"
                  #phone="ngModel" pattern="[+][1][0-9]{10}" placeholder="+1XXXXXXXXXX" maxlength="12" required>
                <small class="text-secondary">Phone Number starts with +1</small>
                <small class="text-danger text-center" *ngIf="phone.errors && inviteProviderAdminForm.submitted">
                  <p class="mb-0" *ngIf="phone.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!phone.errors.required">*Invalid phone</p>
                </small>
              </div>

              <div class="mt-2 text-secondary"><small>Note: An invitation email will go out to Provider admin</small>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
            (click)="resetInviteProviderAdminForm()">Cancel</button>
          <button type="submit" class="btn btn-primary border btn-80">Done</button>
        </div>
      </form>
    </div>
  </div>
</div>